import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollTop() {
  const location = useLocation();
  useEffect(() => {
    // locationを監視して変更された際にスクロール量を0にする(スクロール指定されている場合は無視)
    if (!location.hash) {
      setTimeout(() => window.scrollTo(0, 0), 150);
    }
  }, [location]);

  return null;
}